(function(){
  const configElement=document.querySelector('[data-loveos-cart-cleanup]');
  if(!configElement)return;
  const config=JSON.parse(configElement.textContent);
  if(!config.legacy)return;
  const root=config.root.endsWith('/')?config.root:config.root+'/';
  let blocked=true;
  const locked=[...document.querySelectorAll('cart-items,cart-drawer-items,.additional-checkout-buttons')];
  const previousInert=locked.map(el=>el.inert);
  locked.forEach(el=>el.inert=true);
  const controls=[...document.querySelectorAll('[name="checkout"]')];
  const previousDisabled=controls.map(el=>el.disabled);
  controls.forEach(el=>el.disabled=true);
  function stopCheckout(event){
    const target=event.target;
    if(blocked&&(target.closest?.('[name="checkout"],a[href*="/checkout"]')||event.submitter?.name==='checkout')){
      event.preventDefault();event.stopImmediatePropagation();
    }
  }
  document.addEventListener('click',stopCheckout,true);
  document.addEventListener('submit',stopCheckout,true);
  async function request(path,body){
    const response=await fetch(root+path,body?{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}:{headers:{'Accept':'application/json'},cache:'no-store'});
    if(!response.ok)throw new Error('cart');
    return response.json();
  }
  function needsUpdate(item){
    const p=item.properties||{};
    return String(item.product_id)===String(config.productId)&&(p.Set==='6 + 3 Paar gratis'||['1 kostenloses Wäschenetz zum Vorteilsset','Teil des Vorteilssets'].includes(p.Beigabe));
  }
  async function clean(){
    let cart=await request('cart.js');
    for(let count=0;count<250;count++){
      const item=cart.items.find(needsUpdate);
      if(!item){blocked=false;location.reload();return;}
      cart=await request('cart/change.js',{id:item.key,quantity:item.quantity,properties:window.LoveosCart.packProperties(item.properties)});
    }
    throw new Error('cart');
  }
  clean().catch(()=>{
    locked.forEach((el,i)=>el.inert=previousInert[i]);
    controls.forEach((el,i)=>el.disabled=previousDisabled[i]);
    const message=document.createElement('p');message.className='lv-cart-update-error';message.setAttribute('role','alert');
    message.textContent='Dein Warenkorb konnte noch nicht vollständig aktualisiert werden. Bitte lade die Seite neu, bevor du zur Kasse gehst. ';
    const retry=document.createElement('button');retry.type='button';retry.textContent='Erneut versuchen';retry.addEventListener('click',()=>location.reload());message.append(retry);
    const container=document.querySelector('#cart-errors,#CartDrawer-CartErrors,main');container?.prepend(message);
  });
})();
